import { gql } from '@apollo/client';

import { MARKETING_SEO_OPPORTUNITY_FIELDS } from '../fragments/marketingSeo';

/**
 * ТЗ 0103, этап 4 — правки SEO. Admin и Marketing: настройки рынка и
 * домены, запросы (исключить / вернуть, добавить вручную), вопросы AI,
 * решения по возможностям («В план»). Admin: смета прогона DataForSEO
 * (`runMarketingSeo(dryRun: true)` — бесплатно; настоящий прогон платный,
 * его кнопки в ERP нет — решает владелец).
 *
 * Имена операций НЕ совпадают с полями бэкенда.
 */

/** Рынок (набор, повторы AI, порог разрыва) и домены — одной записью. */
export const SaveMarketingSeoSettingsFormMutation = gql`
  mutation SaveMarketingSeoSettingsForm($input: MarketingSeoSettingsInput!) {
    saveMarketingSeoSettings(input: $input) {
      success
      customErrors {
        field
        code
        message
      }
      settings {
        ownDomain
        locationCode
        languageCode
        device
        depth
        maxTracked
        aiRepeats
        minGapVolume
        excludedTopics
        trackedCount
      }
      domains {
        id
        domain
        label
        isOwn
        active
        source
        brandRegex
        suggestedMetrics
      }
    }
  }
`;

/** Исключить запрос из набора и разрывов — или вернуть / взять в набор. */
export const SaveMarketingSeoKeywordFlagsMutation = gql`
  mutation SaveMarketingSeoKeywordFlags(
    $id: ID!
    $excluded: Boolean
    $tracked: Boolean
  ) {
    saveMarketingSeoKeyword(id: $id, excluded: $excluded, tracked: $tracked) {
      success
      customErrors {
        field
        code
        message
      }
      id
      tracked
      excluded
    }
  }
`;

/** Ручные запросы (до 200 за раз) — в набор, пока есть место. */
export const AddMarketingSeoKeywordsFormMutation = gql`
  mutation AddMarketingSeoKeywordsForm(
    $keywords: [String!]!
    $familySlug: String
  ) {
    addMarketingSeoKeywords(keywords: $keywords, familySlug: $familySlug) {
      success
      customErrors {
        field
        code
        message
      }
      added
      existing
      tracked
      rejected
    }
  }
`;

/** Вопрос AI: новый или правка (правка текста — новая версия). */
export const SaveMarketingSeoQuestionFormMutation = gql`
  mutation SaveMarketingSeoQuestionForm($input: MarketingSeoQuestionInput!) {
    saveMarketingSeoQuestion(input: $input) {
      success
      customErrors {
        field
        code
        message
      }
      question {
        id
        familySlug
        group
        textPl
        active
        sort
        version
        source
      }
    }
  }
`;

/** Удалить вопрос; с ответами — выключить (`deleted: false`). */
export const RemoveMarketingSeoQuestionMutation = gql`
  mutation RemoveMarketingSeoQuestion($id: ID!) {
    deleteMarketingSeoQuestion(id: $id) {
      success
      customErrors {
        field
        code
        message
      }
      deleted
    }
  }
`;

/** Решение по возможностям пакетом: «В план» — `planned`. */
export const DecideMarketingSeoOpportunitiesMutation = gql`
  mutation DecideMarketingSeoOpportunities(
    $ids: [ID!]!
    $status: String!
    $note: String
  ) {
    setMarketingSeoOpportunityStatus(ids: $ids, status: $status, note: $note) {
      success
      customErrors {
        field
        code
        message
      }
      updated
      opportunities {
        ...MarketingSeoOpportunityFields
      }
    }
  }
  ${MARKETING_SEO_OPPORTUNITY_FIELDS}
`;

/**
 * Admin: смета прогона DataForSEO (`dryRun: true` — без внешних вызовов).
 * Настоящий прогон тем же полем ERP не запускает.
 */
export const RunMarketingSeoJobMutation = gql`
  mutation RunMarketingSeoJob($kind: String!, $dryRun: Boolean) {
    runMarketingSeo(kind: $kind, dryRun: $dryRun) {
      success
      customErrors {
        field
        code
        message
      }
      estimate {
        kind
        estimateUsd
        keywords
        questions
        ai
        upperBound
        refusal
        items {
          endpoint
          requests
          results
          costUsd
        }
      }
      queued
      dryRun
    }
  }
`;
